import cogoToast from "cogo-toast";
import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Assessment } from "@material-ui/icons";
import CustomButton from "../../../../../components/CustomButton";
import CustomInput from "../../../../../components/CustomInput";
import LinkButton from "../../../../../components/LinkButton";
import paperclip from "../../../../../assets/icons/paperclip.svg";
import { setResume } from "../../../../../redux/actions/profileActions";
import { uploadFile } from "../../../../../utils/helpers";
import { getProfileAction } from "../../../../../redux/actions/profileActions";
import { useParams, useLocation } from "react-router-dom";
import { jobReferralLinkClicked } from "../../../../../redux/actions/businessActions";

const LoadingMessage = () => {
  const [index, setIndex] = useState(0);
  const messages = [
    "Reading your career history... 📄",
    "Extracting key skills... 💡",
    "Comparing qualifications with role requirements... 🔍",
    "Synthesizing match score... 🧠",
    "Almost there! Adding final touches... ✨",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((old) => (old + 1) % messages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <span style={{ color: "#3A6ED4", fontSize: "14px", fontWeight: "600" }}>
      {messages[index]}
    </span>
  );
};

const Apply = ({ 
  pendingPhone, 
  setPendingPhone, 
  pendingFullName, 
  setPendingFullName, 
  setHasUploadedResume,
  matchScore,
  matchRecommendation,
  matchLoading,
  matchError,
  onCalculateMatch
}) => {
  const dispatch = useDispatch();
  const uploadInputRef = useRef(null);
  const { profile } = useSelector((store) => store);
  const { profileData } = profile;
  const [filename, setFileName] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const { auth } = useSelector((store) => store);
  const { job } = useSelector((store) => store.job);
  const [uploadedResume, setUploadedResume] = useState({});
  const handleRefClick = () => {
    uploadInputRef.current.click();
  };
  const { refLink: paramRefLink, jobId: paramJobId, id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const jobId = paramJobId || id;
  const refLink = paramRefLink || searchParams.get('ref');

  useEffect(() => {
    getProfileAction(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (refLink) {
      jobReferralLinkClicked({
        invited_by_code: refLink,
        job_id: parseInt(jobId),
      });
    }
  }, [refLink]);

  const handleChangeUpload = async ({ target: { files } }) => {
    if (files && files[0]) {
      setIsUploading(true);

      try {
        const response = await uploadFile(
          files[0],
          "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload"
        );
        setFileName(response.fileName);

        const { data, success } = response;

        if (success) {
          cogoToast.success("Resume Uploaded", {
            hideAfter: 4,
            position: "top-center",
          });

          // Use the secure_url from the Cloudinary response
          // const secureUrl = data.secure_url;
          const resumeData = { link: data, name: files[0].name };

          setUploadedResume({ link: data, name: files[0].name });
          setResume(dispatch, { userId: auth.userData.id, ...resumeData });
          if (setHasUploadedResume) setHasUploadedResume(true);
        } else {
          cogoToast.error("Unsuccessful upload", {
            hideAfter: 4,
            position: "top-center",
          });
        }
      } catch (error) {
        cogoToast.error("Upload failed", {
          hideAfter: 4,
          position: "top-center",
        });
      } finally {
        setIsUploading(false);
      }
    }
  };
  // const handleChangeUpload = ({ target: { files } }) => {
  //   if (files && files[0]) {
  //     setIsUploading(true);
  //     Promise.resolve(
  //       uploadFile(
  //         files[0],
  //         "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload"
  //       )
  //     )
  //       .then(({ data, success }) => {
  //         if (success) {
  //           cogoToast.success("Resume Uploaded", {
  //             hideAfter: 4,
  //             position: "top-center",
  //           });
  //           setUploadedResume({ link: data, name: files[0].name });
  //           setResume(dispatch, { userId: auth.userData.id, link: data });
  //         } else {
  //           cogoToast.error("Unsuccessful upload", {
  //             hideAfter: 4,
  //             position: "top-center",
  //           });
  //         }
  //       })
  //       .finally(() => {
  //         setIsUploading(false);
  //       });
  //   }
  // };

  return (
    <main>
      {auth.userData.first_name && auth.userData.last_name ? (
        <CustomInput
          isDisabled
          value={`${auth.userData.first_name} ${auth.userData.last_name}`}
          type="text"
          label="Full Name"
          id="name"
        />
      ) : (
        <CustomInput
          onChange={(e) => setPendingFullName(e.target.value)}
          type="text"
          label="Full Name"
          id="name"
          value={pendingFullName}
          placeholder="Enter your full name"
        />
      )}
      <CustomInput
        isDisabled
        value={auth.userData.email}
        type="text"
        label="Email Address"
        id="email"
      />

      {auth.userData.phone ? (
        <CustomInput
          isDisabled
          type="text"
          label="Phone Number"
          id="phone"
          value={auth.userData.phone}
        />
      ) : (
        <CustomInput
          onChange={(e) => setPendingPhone(e.target.value)}
          type="text"
          label="Phone Number"
          id="phone"
          value={pendingPhone}
        />
      )}

      <div className="w-100">
        {!auth.userData.resume && (
          <div className="co-lightred">You have not uploaded your resume</div>
        )}
        {auth.userData.resume && (
          <>
            <img
              src={paperclip}
              alt="attachment"
              width="12px"
              style={{ marginRight: "5px" }}
            />
            <LinkButton
              label={
                uploadedResume.name ??
                profileData.resumeName ??
                "Your Uploaded CV"
              }
              onClick={() => window.open(`${auth.userData.resume}`, "_blank")}
            />
          </>
        )}
        <h6 style={{ marginTop: "10px", fontWeight: "bold", color: "#3A6ED4" }}>
          {filename}
        </h6>

        <div className="my-4 d-flex">
          <div className="w-50 mr-1">
            <input
              ref={uploadInputRef}
              type="file"
              onChange={handleChangeUpload}
              style={{ display: "none" }}
              accept="application/pdf, .docx"
            />
            <LinkButton
              label="Upload New CV (2MB)"
              onClick={handleRefClick}
              loading={isUploading}
            />
          </div>
        </div>

        <div>
          <p style={{ fontSize: "12px", color: "red" }}>
            {" "}
            By applying, you are granting the job poster access to your user
            profile. It is recommended that you update your profile before
            applying.
          </p>
        </div>

        {/* Check Match Score Button - only for Tier 3 jobs */}
        {job?.job_tier === "3" && !matchLoading && matchScore === null && !matchError && (
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <CustomButton
              backgroundColor="#28a745"
              color="#fff"
              text={
                <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Assessment style={{ marginRight: "8px", fontSize: "18px" }} />
                  Check Match Score
                </span>
              }
              handleClick={() => onCalculateMatch()}
              additionalClass="mt-3"
            />
            <p style={{ fontSize: "12px", color: "#6c757d", marginTop: "8px" }}>
              See how well you match this job based on your profile
            </p>
          </div>
        )}

        {/* Match Score Section - appears after clicking Check Match Score - only for Tier 3 jobs */}
        {job?.job_tier === "3" && (matchScore !== null || matchLoading || matchError) && (
          <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
            <h6 style={{ color: "#3A6ED4", marginBottom: "10px", display: "flex", alignItems: "center" }}>
              <Assessment style={{ marginRight: "8px", fontSize: "18px" }} />
              Your Match Score for this Job
            </h6>
            
            {matchLoading && (
              <div style={{ padding: "10px 0" }}>
                <div style={{ textAlign: "center", marginBottom: "15px" }}>
                  <LoadingMessage />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#adb5bd",
                      marginTop: "8px",
                    }}
                  >
                    AI analysis can take up to 30 seconds to be thorough.
                  </p>
                </div>
                <div
                  style={{
                    height: "6px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "3px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div
                    className="loading-bar-pulse"
                    style={{
                      height: "100%",
                      width: "60%",
                      backgroundColor: "#3A6ED4",
                      borderRadius: "3px",
                    }}
                  />
                </div>
                <style>{`
                  @keyframes loading-pulse {
                    0% { transform: translateX(-100%); width: 30%; }
                    50% { width: 60%; }
                    100% { transform: translateX(400%); width: 30%; }
                  }
                  .loading-bar-pulse {
                    animation: loading-pulse 2s infinite ease-in-out;
                  }
                `}</style>
              </div>
            )}
            
            {matchError && (
              <div style={{ color: "#dc3545", textAlign: "center", padding: "10px" }}>
                {matchError}
              </div>
            )}
            
            {matchScore !== null && !matchLoading && !matchError && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "15px" }}>
                  <div style={{ 
                    fontSize: "36px", 
                    fontWeight: "bold", 
                    color: matchScore >= 80 ? "#28a745" : matchScore >= 60 ? "#ffc107" : "#dc3545",
                    marginBottom: "5px"
                  }}>
                    {matchScore}%
                  </div>
                  <div style={{ fontSize: "14px", color: "#6c757d" }}>
                    Match Score
                  </div>
                </div>
                
                {/* {matchRecommendation && (
                  <div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "5px", marginTop: "10px" }}>
                    <strong>Recommendation:</strong> {matchRecommendation}
                  </div>
                )} */}
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  );
};

export default Apply;

Apply.propTypes = {
  pendingPhone: PropTypes.string,
  setPendingPhone: PropTypes.func,
  pendingFullName: PropTypes.string,
  setPendingFullName: PropTypes.func,
  setHasUploadedResume: PropTypes.func,
  matchScore: PropTypes.number,
  matchRecommendation: PropTypes.string,
  matchLoading: PropTypes.bool,
  matchError: PropTypes.string,
  onCalculateMatch: PropTypes.func,
};
